import { ChildrenProps, appendClassName } from '@componentLibraryWrapper/common';
import { Fade } from '@componentLibraryWrapper/fade';
import { Alert } from '@componentLibraryWrapper/alert';
import './error.scss';

export interface ErrorProps extends ChildrenProps<HTMLDivElement> {
}

const Error = ({
  children,
  className,
  id
}: ErrorProps) => {
  return( 
    <div 
      className={appendClassName('sm-error', className)}
      id={id}>
      <Fade
        in={true}
        timeout={1000}>
        <div>
          <Alert
            children={children}
            id={id}
            severity='error'/>
        </div>
      </Fade>
    </div>
  )
}

export default Error;